(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.document) return;
  root.PinmeFulfillment = api;
  const ids = value => String(value || '').split('/').pop();
  function mount(card) {
    if (card.pinmeFulfillmentController) return;
    let config;
    try { config = JSON.parse(card.querySelector('[data-fulfillment-config]').textContent); } catch { return; }
    const label = (key, fallback) => config.labels?.[key] || fallback;
    const section = card.closest('[data-pinme-product-main]') || card.parentElement;
    const input = section.querySelector('[data-pinme-main-variant],input[name="id"]');
    const fields = {};
    ['stock-text','stock-bar','stock-fill','delivery-heading','delivery-range','delivery-timeline','order-date','ship-date','delivery-date','delivery-note','free-shipping'].forEach(name => fields[name] = card.querySelector('[data-' + name + ']'));
    const estimate = card.querySelector('.pinme-fulfillment__estimate');
    let latestCart = root.PinmeCart?.cart || null;
    let currentId = ids(input?.value || config.variants?.[0]?.id), selectedAvailability = null, snapshot = null, request = 0, aborter = null;
    const text = (name, value) => { if (fields[name]) fields[name].textContent = value; };
    const hide = (name, hidden) => { if (fields[name]) fields[name].hidden = hidden; };
    function variant() {
      const item = (config.variants || []).find(item => ids(item.id) === currentId) || {id:currentId};
      return selectedAvailability === null ? item : {...item, available:selectedAvailability};
    }
    function render() {
      const now = card.pinmeFulfillmentNow ? new Date(card.pinmeFulfillmentNow) : new Date();
      const current = variant();
      let model = api.resolve({variant:current, country:config.country, state:current.state || config.state, initialStock:current.initialStock ?? config.initialStock, snapshot, now});
      const product = {id:config.productId, variantId:currentId, available:model.status === 'sold_out' ? false : current.available};
      for (const key of ['state','source','preorderWindow']) {
        const value = current[key] ?? config[key];
        if (value) product[key] = value;
      }
      const timing = config.timing;
      const transit = timing?.transitDays?.[config.country];
      const deliveryRule = timing ? {processingDays:config.country === 'US' ? timing.processingUS : timing.processingOther,transitMin:config.country === 'US' ? timing.transitMinUS : transit,transitMax:config.country === 'US' ? timing.transitMaxUS : transit} : undefined;
      const shipping = root.PinmeFreeShipping?.evaluate(latestCart || root.PinmeCart?.cart, undefined, {product,deliveryRule});
      const delivery = shipping?.delivery;
      if (delivery?.status === 'preorder' || delivery?.status === 'coming_soon') {
        model = api.resolve({variant:current, country:config.country, state:delivery.status, initialStock:current.initialStock ?? config.initialStock, snapshot, now});
      }
      card.dataset.stockColor = config.stockColor === 'red' ? 'red' : 'green';
      card.dataset.status = model.status;
      card.dataset.variantId = currentId;
      // Purchase state is owned by the native product form, never by the calendar.
      const stockLabel = label(model.status === 'stock' ? 'stock' : model.status, model.label);
      text('stock-text', model.quantity === null ? stockLabel : stockLabel + ' · ' + model.quantity.toLocaleString(config.locale || 'en-US') + ' ' + label('quantity','available'));
      hide('stock-bar', model.ratio === null);
      if (fields['stock-fill']) fields['stock-fill'].style.width = (model.ratio || 0) + '%';
      if (fields['stock-bar']) {
        fields['stock-bar'].setAttribute('aria-valuenow', String(Math.round(model.ratio || 0)));
        fields['stock-bar'].setAttribute('aria-valuetext', model.ratio === null ? '' : Math.round(model.ratio) + label('stock_ratio','% of initial batch available'));
      }
      hide('delivery-timeline', true);
      hide('delivery-heading', true);
      delete card.dataset.deliveryStart;
      delete card.dataset.deliveryEnd;
      if (estimate) estimate.hidden = true;
      text('delivery-range', '');
      let showTimeline = false;
      if (model.status === 'stock' && delivery?.showEstimate && delivery.calendarRule && root.PinmeDeliveryCalendar) {
        try {
          const dates = root.PinmeDeliveryCalendar.calculate(now, delivery.calendarRule);
          const range = root.PinmeDeliveryCalendar.formatRange(dates.deliveryStart, dates.deliveryEnd);
          text('delivery-heading', config.country === 'US' ? label('heading_us','Estimated U.S. delivery') : config.country === 'GB' ? label('heading_gb','Estimated U.K. delivery') : label('heading_other','Estimated delivery'));
          text('delivery-range', range);
          text('order-date', root.PinmeDeliveryCalendar.formatDate(dates.orderDate));
          text('ship-date', root.PinmeDeliveryCalendar.formatDate(dates.shipDate));
          text('delivery-date', range);
          fields['order-date']?.setAttribute('datetime', dates.orderDate);
          fields['ship-date']?.setAttribute('datetime', dates.shipDate);
          card.dataset.deliveryStart = dates.deliveryStart;
          card.dataset.deliveryEnd = dates.deliveryEnd;
          if (estimate) estimate.hidden = false;
          hide('delivery-heading', false);
          hide('delivery-timeline', false);
          showTimeline = true;
        } catch {}
      }
      const stepLabels = ['order_label','ship_label','arrival_label'];
      card.querySelectorAll('.pinme-fulfillment__step-label').forEach((node,index) => { if (config.labels?.[stepLabels[index]]) node.textContent = config.labels[stepLabels[index]]; });
      const note = showTimeline ? String(config.cardNote || '').trim() : delivery ? [delivery.primary || delivery.heading, delivery.detail || delivery.note].filter(Boolean).join(' ') : label('delivery_at_checkout','Delivery options and estimates are shown at checkout.');
      text('delivery-note', note);
      hide('delivery-note', !note);
      text('free-shipping', shipping?.productText || label('shipping_at_checkout','Shipping options are shown at checkout.'));
      hide('free-shipping', model.status !== 'stock');
    }
    async function refresh() {
      const version = ++request, selectedId = currentId;
      aborter?.abort();
      render();
      if (!config.stockEndpoint || config.state === 'coming_soon' || variant().available === false || !selectedId) return;
      let url;
      try {
        url = new URL(config.stockEndpoint, root.location.origin);
        if (url.origin !== root.location.origin || !url.pathname.startsWith('/apps/')) return;
      } catch { return; }
      url.searchParams.set('variant_id', selectedId);
      url.searchParams.set('country', config.country);
      aborter = new AbortController();
      try {
        const response = await root.fetch(url, {signal:aborter.signal,cache:'no-store',credentials:'same-origin',headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('Inventory unavailable');
        const data = await response.json();
        if (version !== request || selectedId !== currentId) return;
        snapshot = data;
        render();
      } catch {
        if (version === request) { snapshot = null; render(); }
      }
    }
    function selected(event) {
      const hasVariant = event?.detail && Object.prototype.hasOwnProperty.call(event.detail, 'variantId');
      const nextId = ids(hasVariant ? event.detail.variantId : input?.value);
      const hasAvailability = typeof event?.detail?.available === 'boolean';
      if (nextId !== currentId) selectedAvailability = null;
      if (hasAvailability) {
        selectedAvailability = event.detail.available;
        const item = (config.variants || []).find(item => ids(item.id) === nextId);
        if (item) item.available = event.detail.available;
      }
      if ((hasVariant || nextId) && (nextId !== currentId || hasAvailability)) { currentId = nextId; snapshot = null; refresh(); }
      else render();
    }
    section.addEventListener('pinme:variant-change', selected);
    section.addEventListener('change', selected);
    const cartUpdated = event => { latestCart = event.detail?.resource || root.PinmeCart?.cart || null; render(); };
    root.document.addEventListener('cart:update', cartUpdated);
    const marketUpdated = event => {
      const market = event.detail?.config?.freeShipping || root.PinmeTheme?.config?.freeShipping || {};
      config.country = event.detail?.country || market.country || '';
      latestCart = event.detail?.cart || root.PinmeCart?.cart || null;
      snapshot = null;
      refresh();
    };
    root.document.addEventListener('pinme:market-updated', marketUpdated);
    const visible = () => { if (!root.document.hidden) refresh(); };
    root.document.addEventListener('visibilitychange', visible);
    root.addEventListener('focus', visible);
    const timer = root.setInterval(visible, 30000);
    card.pinmeFulfillmentController = {
      update(next) { config = {...config,...next}; snapshot = null; render(); },
      refresh,
      destroy() { ++request; aborter?.abort(); root.clearInterval(timer); section.removeEventListener('pinme:variant-change',selected); section.removeEventListener('change',selected); root.document.removeEventListener('cart:update',cartUpdated); root.document.removeEventListener('pinme:market-updated',marketUpdated); root.document.removeEventListener('visibilitychange',visible); root.removeEventListener('focus',visible); delete card.pinmeFulfillmentController; }
    };
    refresh();
  }
  const cards = scope => [...(scope.matches?.('[data-pinme-fulfillment]') ? [scope] : []), ...scope.querySelectorAll('[data-pinme-fulfillment]')];
  const init = scope => cards(scope).forEach(mount);
  root.PinmeFulfillment.init = init;
  if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded',()=>init(root.document),{once:true});
  else init(root.document);
  root.document.addEventListener('shopify:section:load',event=>init(event.target));
  root.document.addEventListener('shopify:section:unload',event=>cards(event.target).forEach(card=>card.pinmeFulfillmentController?.destroy()));
})(typeof window === 'object' ? window : null, function () {
  const id = value => String(value || '').split('/').pop();
  function trustedQuantity(snapshot, variantId, country, now) {
    if (!snapshot || snapshot.scope !== 'variant-market-sellable' || snapshot.reliable !== true || snapshot.tracked !== true) return null;
    if (id(snapshot.variantId) !== id(variantId) || snapshot.country !== country) return null;
    const time = Date.parse(snapshot.fetchedAt), instant = new Date(now).getTime();
    if (!Number.isFinite(time) || !Number.isFinite(instant) || instant-time > 60000 || time-instant > 5000) return null;
    const number = snapshot.availableQuantity;
    return typeof number === 'number' && Number.isSafeInteger(number) && number >= 0 ? number : null;
  }
  function resolve({variant={},country,state='stock',initialStock=0,snapshot=null,now=new Date()}) {
    const quantity = trustedQuantity(snapshot,variant.id,country,now);
    if (state === 'coming_soon') return {status:'coming_soon',label:'Coming soon',quantity:null,ratio:null};
    if (state === 'preorder') return {status:'preorder',label:'Preorder',quantity:null,ratio:null};
    if (quantity === 0 || (quantity === null && variant.available === false)) return {status:'sold_out',label:'Sold out',quantity:null,ratio:null};
    if (quantity === null && variant.available !== true) return {status:'unknown',label:'Availability shown at checkout',quantity:null,ratio:null};
    const denominator = Number(initialStock);
    const ratio = quantity !== null && Number.isFinite(denominator) && denominator > 0 ? Math.max(0,Math.min(100,quantity / denominator * 100)) : null;
    return {status:'stock',label:'In stock',quantity,ratio};
  }
  return {resolve,trustedQuantity};
});


